// Homne.js

import React from 'react';
import Form
 from '../../Form';
const Home = () => {
  return (
    <div className="container mt-4">
    <h2 className="text-center mb-4">Welcome to 4CY Game Studio</h2>
    <p>
      4CY Game Studio is a start-up game development studio dedicated to creating engaging and innovative gaming experiences for players of all ages. With a passion for creativity and technology, we strive to deliver high-quality games that entertain and inspire.
    </p>
    <p>
      Our team of talented developers, designers, and artists work tirelessly to bring our visions to life, pushing the boundaries of game design and storytelling. Whether it's puzzle games, action-adventure, or educational games, we are committed to delivering fun and memorable experiences that captivate our players.
    </p>
    <Form />
     
  </div>
);
};

export default Home;
